import * as React from "react";

import EnableAppEmbedPng from "./EnableAppEmbed.png";

export const EnableAppEmbed = () => {
  return (
    <img
      id="enable-app-embed"
      src={EnableAppEmbedPng}
      alt="Enable App Embed"
      draggable="false"
      style={{ height: "100%", width: "auto", objectFit: "contain" }}
    />
  );
};
